import { debounce } from 'lodash';
import { Noop } from 'react-hook-form';

// copied from original repository - storm/nautiqus, then modified a bit
export function validateEmailArray(emails: (string | { text: string })[]) {
  if (!Array.isArray(emails)) {
    return false;
  }

  for (let i = 0; i < emails.length; ++i) {
    let email = emails[i];
    if (typeof email !== 'string') email = email.text;
    if (email === '') return false;
    if (
      // eslint-disable-next-line no-useless-escape, no-control-regex
      !/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
        email,
      )
    ) {
      return false;
    }
  }

  return true;
}

export const createHandleOnBlur =
  (
    setOptions: React.Dispatch<React.SetStateAction<any>>,
    setParams: React.Dispatch<React.SetStateAction<any>>,
    onBlur: Noop,
  ) =>
  () => {
    onBlur();
    setParams((prev: object) => ({
      ...prev,
      filterText: '',
      pageNumber: 1,
    }));
    setOptions([]);
  };

export const handleChange = (
  setOptions: React.Dispatch<React.SetStateAction<any>>,
  setParams: React.Dispatch<React.SetStateAction<any>>,
) =>
  debounce((value: string) => {
    setOptions([]);
    setParams((prev: object) => ({
      ...prev,
      filterText: value,
      pageNumber: 1,
    }));
  }, 800);
